/**
 * Attribute paths whose initial load has already been evaluated for the
 * "next after selection" preselection jump, scoped to one configuration.
 *
 * The scope is the navigation reset key, which the configuration renderer
 * regenerates whenever a configuration is started, loaded, resumed or fully
 * reset - so starting a new configuration clears the list.
 */
let scopeResetKey: string | undefined;
const evaluatedAttributePaths = new Set<string>();

/**
 * Returns `true` exactly once per attribute path and configuration: the first
 * time the control for that attribute loads. Later loads (e.g. navigating back
 * to the step) return `false`.
 */
export function claimInitialLoad(
  resetKey: string,
  attributePath: string,
): boolean {
  if (scopeResetKey !== resetKey) {
    scopeResetKey = resetKey;
    evaluatedAttributePaths.clear();
  }
  if (evaluatedAttributePaths.has(attributePath)) {
    return false;
  }
  evaluatedAttributePaths.add(attributePath);
  return true;
}
